module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/economics-hover-50.1fd9b96d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/economics-hover-50.png
// module id = 3436
// module chunks = 11